import baseAPI from "@/api/base";
import { AxiosResponse } from "axios";
import type { MessageDraftDto, MessageDraftChannel } from "@/dtos/MessageDraft.dto";

class MessageDraftService {
  private static BASE_URL = "/message-drafts";

  static getDraft = async (
    conversationId: string,
    channel: MessageDraftChannel
  ): Promise<AxiosResponse<{ status: boolean; data: MessageDraftDto | null }>> => {
    const response: AxiosResponse = await baseAPI.get(this.BASE_URL, {
      params: { conversationId, channel },
    });
    return response;
  };

  static saveDraft = async (
    conversationId: string,
    channel: MessageDraftChannel,
    content: string
  ): Promise<AxiosResponse<{ status: boolean; data: MessageDraftDto | null }>> => {
    const response: AxiosResponse = await baseAPI.put(this.BASE_URL, {
      conversationId,
      channel,
      content,
    });
    return response;
  };

  static clearDraft = async (
    conversationId: string,
    channel: MessageDraftChannel
  ): Promise<AxiosResponse<{ status: boolean }>> => {
    const response: AxiosResponse = await baseAPI.delete(this.BASE_URL, {
      params: { conversationId, channel },
    });
    return response;
  };
}

export default MessageDraftService;
